export const ITALIC_BOLD_REGEX = /\*\*\*(.*?)\*\*\*|___(.*?)___/g;
export const BOLD_REGEX = /\*\*(.*?)\*\*|__(.*?)__/;
export const ITALIC_REGEX = /\*(.*?)\*|_(.*?)_/;
